<template>
  <div class="column content-box settings--content">
    <label>
      {{ $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.LABEL_AVATAR') }}
    </label>
    <woot-avatar-uploader
      :label="$t('PROFILE_SETTINGS.FORM.PROFILE_IMAGE.LABEL')"
      :src="avatarUrl"
      class="settings-item"
      @change="handleImageUpload"
    />
    <div v-if="showDeleteButton" class="avatar-delete-btn">
      <woot-button
        type="button"
        color-scheme="alert"
        variant="hollow"
        size="small"
        @click="deleteAvatar"
      >
        {{ $t('PROFILE_SETTINGS.DELETE_AVATAR') }}
      </woot-button>
    </div>
    <small>
      {{
        $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.HELP_TEXT_ACCEPTED_FILE_TYPES')
      }}: JPG, PNG, GIF (máx. 5MB)
    </small>

    <label
      class="medium-9 columns settings-item"
      :class="{ error: $v.name.$error }"
    >
      {{ $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.LABEL_NAME') }}
      <input
        v-model.trim="name"
        type="text"
        name="name"
        :placeholder="
          $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.PLACEHOLDER_NAME')
        "
        @input="$v.name.$touch"
      />
      <span v-if="$v.name.$error" class="message">
        {{ $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.ERROR_NAME') }}
      </span>
    </label>

    <label
      class="medium-9 columns settings-item"
      :class="{ error: $v.description.$error }"
    >
      {{ $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.LABEL_DESCRIPTION') }}
      <textarea
        v-model.trim="description"
        name="description"
        class="textlong"
        :placeholder="
          $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.PLACEHOLDER_DESCRIPTION')
        "
        @input="$v.description.$touch"
      />
      <span v-if="$v.description.$error" class="message">
        {{ $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.ERROR_DESCRIPTION') }}
      </span>
    </label>

    <div class="tab-footer">
      <woot-submit-button
        :disabled="$v.$invalid"
        :loading="isSaving"
        :button-text="$t('INTEGRATION_SETTINGS.ASSISTENT.UPDATE.BUTTON_TEXT')"
        @click="onSubmit"
      />
    </div>
  </div>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import assistentTabMixin from '../../mixins/assistentTabMixin';

export default {
  mixins: [assistentTabMixin],
  data() {
    return {
      avatarFile: null,
      avatarPath: this.assistent.avatar || null,
      avatarRemoved: false,
      name: this.assistent.name || '',
      description: this.assistent.description || '',
    };
  },
  validations: {
    name: {
      required,
      minLength: minLength(3),
    },
    description: {
      maxLength: maxLength(512),
    },
  },
  computed: {
    avatarUrl() {
      return this.avatarPath || '';
    },
    showDeleteButton() {
      return !!this.avatarPath;
    },
  },
  methods: {
    handleImageUpload({ file, url }) {
      this.avatarFile = file;
      this.avatarPath = url;
      this.avatarRemoved = false;
    },
    deleteAvatar() {
      this.avatarFile = null;
      this.avatarPath = null;
      this.avatarRemoved = true;
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const formData = new FormData();
      formData.append('id', this.assistent.id);
      formData.append('assistent[name]', this.name);
      formData.append('assistent[description]', this.description || '');
      if (this.avatarFile instanceof File) {
        formData.append('assistent[avatar]', this.avatarFile);
      } else if (this.avatarRemoved) {
        formData.append('assistent[avatar]', '');
      }

      await this.saveAssistent(formData);
    },
  },
};
</script>

<style scoped lang="scss">
@import './tabs-shared.scss';
</style>
